var map = {
	"./adjective.svg": 43972,
	"./adjektiv.svg": 16709,
	"./adverb.svg": 12585,
	"./article.svg": 94509,
	"./artikel.svg": 71546,
	"./conjunction.svg": 22748,
	"./konjunktion.svg": 66294,
	"./nomen.svg": 28741,
	"./noun.svg": 2030,
	"./numeral.svg": 69528,
	"./numerals.svg": 5108,
	"./other.svg": 78208,
	"./phrase.svg": 89097,
	"./preposition.svg": 66371,
	"./pronoun.svg": 97195,
	"./test.svg": 64815,
	"./thin.svg": 32204,
	"./verb.svg": 97252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52886;